module.exports = __webpack_public_path__ + "img/product-2-lanya.fd3c557e.png";